import {FC} from 'react'
import {ID} from '../../../../../_metronic/helpers'
import {ClassifiedPost} from '../../core/_models'

type Props = {
  post: ClassifiedPost
  id: ID
}

const InfoCell: FC<Props> = ({post}) => (
  <div className='d-flex align-items-center'>
    {/* Avatar */}
    <div className='symbol symbol-50px me-3'>
      <img
        src={post.mainImage || '/media/svg/files/blank-image.svg'}
        alt={post.title}
        className='object-fit-cover'
      />
    </div>

    {/* Info */}
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1 fw-bold'>
        {post.title}
      </a>
      <span className='text-muted fw-semibold text-muted d-block fs-7'>
        {post.location?.city && `${post.location.city}, ${post.location.state}`}
      </span>
      {post.views !== undefined && (
        <span className='text-muted fw-semibold text-muted d-block fs-8'>
          👁 {post.views} views
        </span>
      )}
    </div>
  </div>
)

export {InfoCell}

